module.exports = __webpack_public_path__ + "static/media/next-arrow.22572277.svg";